<template>
    <tr>
        <td>
            <div class="form-group mb-0">
                <input type="text" class="form-control" v-model="label">
                <small v-if="errors && errors.label" class="form-text text-warning">
                    {{ errors.label }}
                </small>
            </div>
        </td>
        <td>
            <div class="form-group mb-0">
                <select class="custom-select" v-model="name">
                    <option value="" disabled>-- CHOOSE MAP --</option>
                    <option v-for="(option, index) in options"
                            :key="index"
                            :value="option.name"
                            :selected="name === option.name">{{option.name}}
                    </option>
                </select>
                <small v-if="errors && errors.name" class="form-text text-warning">
                    {{ errors.name }}
                </small>
            </div>
        </td>
        <td>
            <button class="btn btn-danger mb-0" @click.prevent="$emit('delete')">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </td>
    </tr>
</template>

<style scoped lang="scss">
    .form-text{
        position: absolute;
    }
</style>

<script>
    export default {
        name: 'field-row',
        model: {
            prop: 'rowData',
            event: 'input',
        },
        props: {
            rowData: {
                type: Object,
            },
            options: {
                type: Array,
            },
        },
        data() {
            return {
                label: null,
                name: null,
                type: null,
                field: null,
                errors: null,
            };
        },
        mounted() {
            this.updateLocalData(this.rowData);
            this.updateParent();
        },
        watch: {
            'rowData': {
                handler(newRow) {
                    this.updateLocalData(newRow);
                },
                deep: true,
            },
            'options': {
                handler() {
                    this.name = this.getOptionName(this.field, this.type);
                },
                deep: true,
            },
            label: function () {
                this.updateParent();
            },
            name: function (name) {
                const option = this.options.find(option => option.name === name);

                if (!option) {
                    this.name = this.type = this.field = null;
                    return;
                }

                this.name = option.name;
                this.type = option.value.type;
                this.field = option.value.field;

                this.updateParent();
            },
        },
        methods: {
            updateParent() {
                this.$emit('input', {
                    label: this.label,
                    type: this.type,
                    field: this.field,
                    errors: this.errors,
                });
            },
            updateLocalData(row) {
                this.label = row.label;
                this.type = row.type;
                this.field = row.field;
                this.name = this.getOptionName(this.field, this.type);
                this.errors = row.errors;
            },
            getOptionName(field, type) {
                if (!this.options) {
                    return null;
                }
                const option = this.options.find(option => (option.value.field === field && option.value.type === type));
                return option ? option.name : null;
            }
        }
    };
</script>
